<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="источник исполнителя"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getWorkerSource"
      :get-list="getItems"
      :can-create-catalog="canEditWorkerSource()"
      :drop-up="dropUp"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <worker-source
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import WorkerSource from "./WorkerSource.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "WorkerSourceSelect",
  components: { CatalogSelect, WorkerSource },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    value: { type: Number, default: null },
    dropUp: { type: Boolean, default: false },
    state: { type: Boolean, default: null }
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getWorkerSources({});
      return (result && result.data && result.data.items) ? result.data.items : [];
    },
    async getWorkerSource(id) {
      const result = await this.getWorkerSourceById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditWorkerSource() {
      return this.hasPermission([PERM.CATALOG_WORKER_SOURCE_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSources/WorkerSourceSelect.vue